import { render, staticRenderFns } from "./DeleteFleet.vue?vue&type=template&id=6b243804&scoped=true"
import script from "./DeleteFleet.vue?vue&type=script&lang=js"
export * from "./DeleteFleet.vue?vue&type=script&lang=js"
import style0 from "./DeleteFleet.vue?vue&type=style&index=0&id=6b243804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b243804",
  null
  
)

export default component.exports